import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {AccountSearchData} from "./account-search.data";

@Injectable()
export class AccountSearchModel extends SearchModel<AccountSearchData> {
    static readonly ACCOUNTING_TYPE_FILTER_NAME: string = "accountingType";

    constructor(injector: Injector) {
        super(injector, AccountSearchData);
    }

    override getIdentifierField(): string {
        return "accountId";
    }

    override isEntityLocalisable(): boolean {
        return true;
    }
}
